import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          <div className="logo">
            <span className="logo-icon">🎮</span>
            <span className="logo-text">مصاقيل</span>
          </div>
          <ul className="nav-links">
            <li><a onClick={() => scrollToSection('hero')}>الرئيسية</a></li>
            <li><a onClick={() => scrollToSection('demo')}>جرب اللعبة</a></li>
            <li><a onClick={() => scrollToSection('features')}>مميزاتنا</a></li>
            <li><a onClick={() => scrollToSection('partners')}>الشراكات</a></li>
            <li><a onClick={() => scrollToSection('contact')} className="cta-btn">تواصل معنا</a></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
